type Item = { id: string; rank: number; listFieldTemplateId: string | null };

/*
 * Sort by rank, within a rank by listFieldTemplateId
 */
const sortByItem = (a: Item, b: Item): number => {
  if (a.rank === b.rank) {
    if (a.listFieldTemplateId && b.listFieldTemplateId) {
      if (a.listFieldTemplateId > b.listFieldTemplateId) {
        return 1;
      }
      if (a.listFieldTemplateId < b.listFieldTemplateId) {
        return -1;
      }
      return 0;
    }

    if (a.listFieldTemplateId) {
      return 1;
    }

    if (b.listFieldTemplateId) {
      return -1;
    }

    return 0;
  }

  return a.rank - b.rank;
};

const reorderFieldTemplates = <I extends Item>({ allItems, direction, item }: {
  allItems: I[];
  direction: 'up' | 'down';
  item: Item;
}): I[] => {

  const otherParents = allItems.filter(i => i.listFieldTemplateId !== item.listFieldTemplateId);
  const sameParents = allItems
    .filter(i => i.listFieldTemplateId === item.listFieldTemplateId)
    .sort(sortByItem);

  const thisItemIndex = sameParents.findIndex(i => i.id === item.id);
  const thisItem = allItems.find(i => i.id === item.id);

  if (
    !thisItem
    || thisItemIndex < 0
    || (thisItemIndex === 0 && direction === 'up')
    || (thisItemIndex === sameParents.length - 1 && direction === 'down')
  ) {
    return allItems.sort(sortByItem);
  }

  const newIndex = thisItemIndex + (direction === 'up' ? -1 : 1);
  const otherItem = sameParents[newIndex];

  sameParents[newIndex] = thisItem;
  sameParents[thisItemIndex] = otherItem;

  return [
    ...otherParents,
    ...sameParents.map((i, index) => ({
      ...i,
      rank: index + 1,
    })),
  ].sort(sortByItem);
};

export default reorderFieldTemplates;